
  const OptListByDate =[
    {
        "OPTDate": "20-07-21",
        "Total":"7",
        "Fresh": "9",
        "Review": "7",
        "Male":"7",
        "Female":"6",
        "CrossReff":"4",
        "Dillated":"3",
        "WalkIn":"3",
        "WithAppt":"8",
        "TAT":"2345"
    },
    {
      "OPTDate": "19-07-21",
      "Total":"2",
      "Fresh": "5",
      "Review": "7",
      "Male":"8",
      "Female":"6",
      "CrossReff":"4",
      "Dillated":"3",
      "WalkIn":"3",
      "WithAppt":"8",
      "TAT":"1345"
  },
  {
    "OPTDate": "18-07-21",
    "Total":"9",
    "Fresh": "5",
    "Review": "7",
    "Male":"0",
    "Female":"6",
    "CrossReff":"4",
    "Dillated":"3",
    "WalkIn":"3",
    "WithAppt":"8",
    "TAT":"1745"
},


{
  "OPTDate": "17-07-21",
  "Total":"3",
  "Fresh": "5",
  "Review": "7",
  "Male":"3",
  "Female":"6",
  "CrossReff":"4",
  "Dillated":"3",
  "WalkIn":"3",
  "WithAppt":"5",
  "TAT":"745"
},

{
  "OPTDate": "16-07-21",
  "Total":"3",
  "Fresh": "5",
  "Review": "6",
  "Male":"3",
  "Female":"0",
  "CrossReff":"4",
  "Dillated":"3",
  "WalkIn":"3",
  "WithAppt":"5",
  "TAT":"945"
},
{
  "OPTDate": "15-07-21",
  "Total":"3",
  "Fresh": "5",
  "Review": "6",
  "Male":"3",
  "Female":"0",
  "CrossReff":"4",
  "Dillated":"3",
  "WalkIn":"3",
  "WithAppt":"5",
  "TAT":"945"
},

{
  "OPTDate": "14-07-21",
  "Total":"3",
  "Fresh": "5",
  "Review": "6",
  "Male":"3",
  "Female":"0",
  "CrossReff":"8",
  "Dillated":"9",
  "WalkIn":"3",
  "WithAppt":"3",
  "TAT":"745"
},

{
  "OPTDate": "13-07-21",
  "Total":"6",
  "Fresh": "5",
  "Review": "7",
  "Male":"9",
  "Female":"0",
  "CrossReff":"0",
  "Dillated":"3",
  "WalkIn":"4",
  "WithAppt":"5",
  "TAT":"845"
},

{
  "OPTDate": "12-07-21",
  "Total":"6",
  "Fresh": "0",
  "Review": "0",
  "Male":"9",
  "Female":"8",
  "CrossReff":"0",
  "Dillated":"4",
  "WalkIn":"4",
  "WithAppt":"5",
  "TAT":"895"
},

{
  "OPTDate": "11-07-21",
  "Total":"6",
  "Fresh": "5",
  "Review": "8",
  "Male":"0",
  "Female":"7",
  "CrossReff":"4",
  "Dillated":"3",
  "WalkIn":"4",
  "WithAppt":"3",
  "TAT":"2340"
},

];


const  OptListByMonth = [
  {
      "OPTMonth": "01-jan",
      "Total":"87",
      "Fresh": "79",
      "Review": "76",
      "Male":"57",
      "Female":"46",
      "CrossReff":"34",
      "Dillated":"37",
      "WalkIn":"83",
      "WithAppt":"78",
      "TAT":"7345"
  },
  {
    "OPTMonth": "02-Feb",
    "Total":"32",
    "Fresh": "45",
    "Review": "67",
    "Male":"81",
    "Female":"66",
    "CrossReff":"64",
    "Dillated":"37",
    "WalkIn":"83",
    "WithAppt":"88",
    "TAT":"8345"
},
{
  "OPTMonth": "03-Mar",
  "Total":"19",
  "Fresh": "25",
  "Review": "57",
  "Male":"30",
  "Female":"56",
  "CrossReff":"34",
  "Dillated":"23",
  "WalkIn":"73",
  "WithAppt":"28",
  "TAT":"5745"
},


{
"OPTMonth": "04-Apr",
"Total":"93",
"Fresh": "85",
"Review": "67",
"Male":"53",
"Female":"46",
"CrossReff":"34",
"Dillated":"23",
"WalkIn":"33",
"WithAppt":"25",
"TAT":"4545"
},

{
"OPTMonth": "05-May",
"Total":"23",
"Fresh": "35",
"Review": "16",
"Male":"53",
"Female":"60",
"CrossReff":"74",
"Dillated":"83",
"WalkIn":"53",
"WithAppt":"35",
"TAT":"7845"
},
{
"OPTMonth": "06-jun",
"Total":"31",
"Fresh": "52",
"Review": "36",
"Male":"34",
"Female":"20",
"CrossReff":"34",
"Dillated":"63",
"WalkIn":"73",
"WithAppt":"65",
"TAT":"1045"
},

{
"OPTMonth": "07-july",
"Total":"43",
"Fresh": "35",
"Review": "46",
"Male":"53",
"Female":"30",
"CrossReff":"48",
"Dillated":"59",
"WalkIn":"73",
"WithAppt":"83",
"TAT":"4745"
},

{
"OPTMonth": "08-Aug",
"Total":"36",
"Fresh": "25",
"Review": "47",
"Male":"39",
"Female":"30",
"CrossReff":"20",
"Dillated":"33",
"WalkIn":"24",
"WithAppt":"15",
"TAT":"1045"
},

{
"OPTMonth": "09-Sep",
"Total":"26",
"Fresh": "30",
"Review": "20",
"Male":"29",
"Female":"28",
"CrossReff":"30",
"Dillated":"44",
"WalkIn":"41",
"WithAppt":"35",
"TAT":"1095"
},

{
"OPTMonth": "10-Oct",
"Total":"16",
"Fresh": "25",
"Review": "38",
"Male":"40",
"Female":"37",
"CrossReff":"24",
"Dillated":"33",
"WalkIn":"24",
"WithAppt":"13",
"TAT":"2340"
},
{
"OPTMonth": "11-Nov",
"Total":"33",
"Fresh": "53",
"Review": "26",
"Male":"32",
"Female":"02",
"CrossReff":"41",
"Dillated":"32",
"WalkIn":"32",
"WithAppt":"25",
"TAT":"1945"
},

{
"OPTMonth": "12-Dec",
"Total":"43",
"Fresh": "35",
"Review": "26",
"Male":"53",
"Female":"30",
"CrossReff":"28",
"Dillated":"19",
"WalkIn":"33",
"WithAppt":"23",
"TAT":"1545"
},


];


const  OptListByDoctor = [
  {
      "DoctorName": "Dr. Anshul Kaushal",
      "Total":"87",
      "Fresh": "79",
      "Review": "76",
      "Male":"57",
      "Female":"46",
      "CrossReff":"34",
      "Dillated":"37",
      "WalkIn":"83",
      "WithAppt":"78",
      "TAT":"7345"
  },
  {
    "DoctorName": "Dr. Arjun Singh",
    "Total":"32",
    "Fresh": "45",
    "Review": "67",
    "Male":"81",
    "Female":"66",
    "CrossReff":"64",
    "Dillated":"37",
    "WalkIn":"83",
    "WithAppt":"88",
    "TAT":"8345"
},
{
  "DoctorName": "Dr. Anita Kumar",
  "Total":"19",
  "Fresh": "25",
  "Review": "57",
  "Male":"30",
  "Female":"56",
  "CrossReff":"34",
  "Dillated":"23",
  "WalkIn":"73",
  "WithAppt":"28",
  "TAT":"5745"
},


{
"DoctorName": "Dr. Rohit Grover",
"Total":"93",
"Fresh": "85",
"Review": "67",
"Male":"53",
"Female":"46",
"CrossReff":"34",
"Dillated":"23",
"WalkIn":"33",
"WithAppt":"25",
"TAT":"4545"
},

{
  "DoctorName": "Dr. Ratan Raj",
"Total":"23",
"Fresh": "35",
"Review": "16",
"Male":"53",
"Female":"60",
"CrossReff":"74",
"Dillated":"83",
"WalkIn":"53",
"WithAppt":"35",
"TAT":"7845"
},
{
  "DoctorName": "Dr. Sujata Grover",
"Total":"31",
"Fresh": "52",
"Review": "36",
"Male":"34",
"Female":"20",
"CrossReff":"34",
"Dillated":"63",
"WalkIn":"73",
"WithAppt":"65",
"TAT":"1045"
},

{
  "DoctorName": "Dr. Suni Solanki",
"Total":"43",
"Fresh": "35",
"Review": "46",
"Male":"53",
"Female":"30",
"CrossReff":"48",
"Dillated":"59",
"WalkIn":"73",
"WithAppt":"83",
"TAT":"4745"
},

{
  "DoctorName": "Dr. Pushpendra Thakur",
"Total":"36",
"Fresh": "25",
"Review": "47",
"Male":"39",
"Female":"30",
"CrossReff":"20",
"Dillated":"33",
"WalkIn":"24",
"WithAppt":"15",
"TAT":"1045"
},

{
"DoctorName": "Dr. Dipak Thakur",
"Total":"26",
"Fresh": "30",
"Review": "20",
"Male":"29",
"Female":"28",
"CrossReff":"30",
"Dillated":"44",
"WalkIn":"41",
"WithAppt":"35",
"TAT":"1095"
},

{

  "DoctorName": "Dr. Pankaj Kumar",
"Total":"16",
"Fresh": "25",
"Review": "38",
"Male":"40",
"Female":"37",
"CrossReff":"24",
"Dillated":"33",
"WalkIn":"24",
"WithAppt":"13",
"TAT":"2340"
},
{

  "DoctorName": "Dr. Sanjay Parihar",
"Total":"33",
"Fresh": "53",
"Review": "26",
"Male":"32",
"Female":"02",
"CrossReff":"41",
"Dillated":"32",
"WalkIn":"32",
"WithAppt":"25",
"TAT":"1945"
},

{

  "DoctorName": "Dr. Naynesh Bhatia",
"Total":"43",
"Fresh": "35",
"Review": "26",
"Male":"53",
"Female":"30",
"CrossReff":"28",
"Dillated":"19",
"WalkIn":"33",
"WithAppt":"23",
"TAT":"1545"
},


];

const  SurgonWiseMonth = [
  {
      "DoctorName": "Dr. Anshul Kaushal",
      "Month": "01-Jan"
  },
  {
    "DoctorName": "Dr. Aakash Singh",
     "Month": "02-Feb"
   },

   {
    "DoctorName": "Dr. Pamkaj Chouhan",
     "Month": "03-Mar"
   },
   {
    "DoctorName": "Dr. Pawan Patidar",
     "Month": "04-Apr"
   },
   {
    "DoctorName": "Dr. Rohit Sharma",
     "Month": "05-May"
   },
   {
    "DoctorName": "Dr. Lokesh Rahul",
     "Month": "06-Jun"
   },
   {
    "DoctorName": "Dr. Radhika Solanki",
     "Month": "07-Jul"
   },
   {
    "DoctorName": "Dr. Anik Soni",
     "Month": "08-Aug"
   },
   {
    "DoctorName": "Dr. Hemant Rathore",
     "Month": "09-Sep"
   },
   {
    "DoctorName": "Dr. Raju Ranjan",
     "Month": "10-Oct"
   },

   {
    "DoctorName": "Dr. Nitin Pal",
     "Month": "11-Nov"
   },
   {
    "DoctorName": "Dr.Jitendra Yadav",
     "Month": "10-Dec"
   },
]


export { OptListByDate };

export { OptListByMonth };
export { OptListByDoctor };